export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-de-DE.07a0a187.xlsx";